import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'

import App from './App.jsx'
import { store } from './store/index.js'
import ThemeWrapper from './components/ThemeWrapper.jsx'
import ClerkProviderWrapper from './components/ClerkProviderWrapper.jsx'
import ClerkSessionSync from './components/ClerkSessionSync.jsx'
import SupabaseSessionSync from './components/SupabaseSessionSync.jsx'
import { isClerkEnabled } from './config/clerkConfig.js'
import { isAuthEnabled as isSupabaseEnabled } from './config/supabaseClient.js'
import { initSentry } from './utils/sentry.js'

// Inicializar Sentry lo mas temprano posible (no-op si VITE_SENTRY_DSN no esta)
initSentry()

// Selección de proveedor de auth (flag-gated, no rompe el flujo actual):
//   - VITE_USE_SUPABASE=true  -> Supabase (supabase-js es global, sin <Provider>)
//   - VITE_USE_CLERK=true     -> Clerk (<ClerkProvider> + sync)
//   - ninguno                 -> auth legacy
const useSupabase = isSupabaseEnabled()
const useVercelAnalytics = import.meta.env.VITE_VERCEL_WEB_ANALYTICS_ENABLED === 'true'
const useVercelSpeedInsights = import.meta.env.VITE_VERCEL_SPEED_INSIGHTS_ENABLED === 'true'

const tree = (
  <ThemeWrapper>
    <CssBaseline />
    <App />
  </ThemeWrapper>
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {useSupabase ? (
          <>
            <SupabaseSessionSync />
            {tree}
          </>
        ) : (
          <ClerkProviderWrapper>
            {isClerkEnabled() && <ClerkSessionSync />}
            {tree}
          </ClerkProviderWrapper>
        )}
        {useVercelAnalytics && <Analytics />}
        {useVercelSpeedInsights && <SpeedInsights />}
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
